
import { Link, useLocation, useParams } from "react-router-dom";
import Layout from "../../Layout";
import { FormEvent, useEffect, useState } from 'react';
import { formatCurrency, getCurrencySymbol } from 'helpers';
import { makeGetRequest, makePatchRequest } from 'request';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import MOTChangeRequestWorkflow from 'components/MOTChangeRequestWorkflow';


const ModeOfTransportationDetail =  () => {
    const param = useParams()
    const location = useLocation()
    const statusAfterNavigation = location.state as { status: string };
    const [modeOfTransportation, setModeOfTransportation] = useState<Record <string, any>>({})
    const [isSubmitting, setIsSubmitting] = useState(false)
    const user: any = useSelector((state: any) => state.tepngUser.value);
    const [formData, setFormData] = useState({
        modeOfTransportationId: param.id,
        estimatedCostSeaFreight: 0,
        estimatedCostAirFreight: 0,
        freightCostCurrency: "USD",
        shippingOfficerId: user?.id,
        shippingOfficerCheck: "Approved",
        estimatedDimensions: "",
        estimatedWeight: "",
    })
    const [errorData, setErrorData] = useState({
        estimatedCostSeaFreight: "",
        estimatedCostAirFreight: "",
        freightCostCurrency: "",
        estimatedDimensions: "",
        estimatedWeight: "",
    })
    
    const clearFormData = () => {
        setFormData({
            modeOfTransportationId: param.id,
            estimatedCostSeaFreight: 0,
            estimatedCostAirFreight: 0,
            freightCostCurrency: "USD",
            estimatedDimensions: "",
            estimatedWeight: "",
            shippingOfficerCheck: "Approved",
            shippingOfficerId: user?.id,
        })
    }
    const handleInputChange = (e: any) => {
        const {name, value} = e.target
        setFormData({...formData, [name]: value})
    }

    

    const getModeOfTransportationById = () => {        
        var request = {
            what: "getModeOfTransportationById",
            id: param.id,
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                const res = response.data.data
                setModeOfTransportation(res)
            })
            .catch((error) => 
                {console.log(error)}
            );
    }

    const handleUpdateMOTInformation = (event: FormEvent) => {
        event.preventDefault()       

        const data = {
            modeOfTransportationId: formData.modeOfTransportationId,
            estimatedCostSeaFreight: formData.estimatedCostSeaFreight,
            estimatedCostAirFreight: formData.estimatedCostAirFreight,
            freightCostCurrency: formData.freightCostCurrency,
            shippingOfficerId: user?.id,
            shippingOfficerCheck: "Approved",            
        }

        // const isAirFreightGreaterThanSeaFreight = Number(data.estimatedCostAirFreight) > Number(data.estimatedCostSeaFreight)
        // if(!isAirFreightGreaterThanSeaFreight) toast.error("Air Freight must be greater than Sea Freight")      
        
        // if(isAirFreightGreaterThanSeaFreight) {
            setIsSubmitting(true)
            var request = {
                what: "UpdateMOTInformationWithMultiplePackages",
                data: data,
            };

            makePatchRequest(request)
                .then((response: any) => {
                    setIsSubmitting(false)
                    toast.success(response.msg)  
                    clearFormData()
                    setTimeout(() => {
                        window.location.reload();
                    }, 700);
                })
                .catch((error) => 
                    {toast.error(error); setIsSubmitting(false);}
                );
        // }else toast.warning("Please provide information for all required fields"); setIsSubmitting(false)
    }

    useEffect(() => {
        getModeOfTransportationById()
       //eslint-disable-next-line 
    }, []);

    const page = "Mode Of Transportation Change"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">                    
                    <div className="main-inner mt-2">                  
                        <div className="detail-top-section">
                            <Link to="/transitofficer/modeoftransportationchange" state={{status: statusAfterNavigation?.status}} className="actions">
                                <p><span className="material-symbols-rounded">arrow_back</span> Back to Mode of Transportation</p>
                            </Link>

                            <div className="tab">
                                <div className="tab-item active">
                                    <span className="material-symbols-rounded">description</span>
                                    <p>Preview Mode Of Transportation Request</p>
                                </div>    
                            </div>                      
                        </div>
                    </div>                    
                                        
                    <MOTChangeRequestWorkflow role="" />

                    {(modeOfTransportation?.estimatedCostSeaFreight === 0 && modeOfTransportation?.estimatedCostAirFreight === 0)
                        && <div className="main-inner mt-1">   
                            <div className="summary-title">
                                Mode of Transportation Analysis
                            </div>                      
                            <form onSubmit={handleUpdateMOTInformation} className="form-view-container for-mot">
                                <div className='d-grid-3'>                                    
                                    <div className='form-item span-col-1'  style={{height: "fit-content"}}>
                                        <label><span className="errorX mr-2">*</span>Frieght Cost Currency</label>
                                        <select name="freightCostCurrency" value={formData.freightCostCurrency} onChange={handleInputChange} required>
                                            <option value="" disabled >Select...</option>
                                            <option value="NGN" >NGN</option>
                                            <option value="USD" >USD</option>
                                            <option value="GBP" >GBP</option>
                                            <option value="EUR" >EUR</option>
                                        </select>
                                        <p className="error"></p>
                                    </div> 
                                    <div className='form-item span-col-1' style={{height: "fit-content"}}>
                                        <label><span className="errorX mr-2">*</span>Estimated Sea Freight Cost</label>
                                        <div style={{display: "flex"}}>
                                            <input name="estimatedCostSeaFreight" 
                                            style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}} 
                                                disabled={!formData.freightCostCurrency}
                                                value={formData?.estimatedCostSeaFreight} onChange={handleInputChange} type='number' required
                                                onKeyUp={() => {Number(formData.estimatedCostSeaFreight) < 0 ? setErrorData({ ...errorData, estimatedCostSeaFreight: 'This field is required' }) : 
                                                setErrorData({ ...errorData, estimatedCostSeaFreight: '' })}} />
                                            <input
                                            style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
                                            type="text" disabled value={`${getCurrencySymbol(formData?.freightCostCurrency)} ${formatCurrency(formData?.estimatedCostSeaFreight)}`} />
                                        </div>                                    
                                        <p className="error">{ errorData?.estimatedCostSeaFreight }</p>
                                    </div>
                                    <div className='form-item span-col-1' style={{height: "fit-content"}}>
                                        <label><span className="errorX mr-2">*</span>Estimated Air Freight Cost</label>
                                        <div style={{display: "flex"}}>
                                            <input name="estimatedCostAirFreight"
                                                style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}} 
                                                disabled={!formData.freightCostCurrency}
                                                value={formData?.estimatedCostAirFreight} 
                                                onChange={handleInputChange} 
                                                type='number' 
                                                required
                                                onKeyUp={() => {Number(formData.estimatedCostAirFreight) < 0 ? setErrorData({ ...errorData, estimatedCostAirFreight: 'This field is required' }) : 
                                                setErrorData({ ...errorData, estimatedCostAirFreight: '' })}} />       
                                            <input
                                            style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
                                            type="text" disabled value={`${getCurrencySymbol(formData?.freightCostCurrency)} ${formatCurrency(formData?.estimatedCostAirFreight)}`} />
                                        </div>                                                                   
                                        <p className="error">{ errorData?.estimatedCostAirFreight }</p>
                                    </div>                                                 
                                </div>    
                                
                                <button 
                                    disabled={isSubmitting}
                                    style={{width: "100%", marginTop: '40px'}}
                                    className='custom-button orange-outline d-flex-center' 
                                    type='submit'>{isSubmitting ? 'Saving...' : 'Save Changes'}
                                </button> 
                            </form>
                        </div>}
                </div>
                <ToastContainer />
            </div>
        </Layout>
        
    )
}

export default ModeOfTransportationDetail